import { root, subdomains } from "@/common/consts";

export const items = [
    {
        label: "itemDictionary",
        url: `${root.WWW}/dictionary-definitions/`
    },
    {
        label: "itemThesaurus",
        url: `${root.THESAURUS}/`
    },
    {
        label: "itemExamples",
        url: `${root.EXAMPLES}/`
    },
    {
        label: "itemSentences",
        url: `${root.SENTENCES}/`
    },
    {
        label: "itemQuotes",
        url: `${root.QUOTES}/`
    },
    {
        label: "itemReference",
        url: `${root.REFERENCE}/`
    },
    {
        label: "itemSpanish",
        url: `${root.SPANISH}/`
    }
];

export const WFItems = [
    {
        label: "itemWordFinder",
        link: `${root.WORDFINDER}`
    },
    {
        label: `wfSubMenu1`,
        link: `${root.WORDFINDER}/4pics1word/`
    },
    {
        label: `wfSubMenu2`,
        link: `${root.WORDFINDER}/anagram-solver/`
    },
    {
        label: `wfSubMenu3`,
        link: `${root.WORDFINDER}/scrabble-dictionary/`
    },
    {
        label: `wfSubMenu4`,
        link: `${root.WORDFINDER}/unscramble/`
    },
    {
        label: `wfSubMenu5`,
        link: `${root.WORDFINDER}/word-cookies/`
    },
    {
        label: `wfSubMenu6`,
        link: `${root.WORDFINDER}/scrabble-checker/`
    },
    {
        label: `wfSubMenu7`,
        link: `${root.WORDFINDER}/words-with-friends-cheat/`
    },
    {
        label: `wfSubMenu8`,
        link: `${root.WORDFINDER}/game-cheats/`
    }
];

export const detailPageNavigation = [
    {
        label: `itemDictionary`,
        link: `${root.WWW}/dictionary-definitions/`,
        subdomain: subdomains.WWW,
        expanded: false
    },
    {
        label: `itemThesaurus`,
        link: `${root.THESAURUS}/`,
        subdomain: subdomains.THESAURUS,
        expanded: false
    },
    {
        label: `itemExamples`,
        link: `${root.EXAMPLES}/`,
        subdomain: subdomains.EXAMPLES,
        expanded: false
    },
    {
        label: `itemSentences`,
        link: `${root.SENTENCES}/`,
        subdomain: subdomains.SENTENCES,
        expanded: false
    },
    {
        label: `itemQuotes`,
        link: `${root.QUOTES}/`,
        subdomain: subdomains.QUOTES,
        expanded: false
    },
    {
        label: `itemReference`,
        link: `${root.REFERENCE}/`,
        subdomain: subdomains.REFERENCE,
        expanded: false
    },
    {
        label: `itemSpanish`,
        link: `${root.SPANISH}/`,
        subdomain: subdomains.SPANISH,
        expanded: false
    },
    {
        label: `itemWordFinder`,
        link: `${root.WORDFINDER}/`,
        icon: `icon-wf-spot`,
        subdomain: subdomains.WORDFINDER,
        expanded: false,
        submenu: [
            {
                label: `wfSubMenu1`,
                link: `${root.WORDFINDER}/4pics1word/`
            },
            {
                label: `wfSubMenu2`,
                link: `${root.WORDFINDER}/anagram-solver/`
            },
            {
                label: `wfSubMenu3`,
                link: `${root.WORDFINDER}/scrabble-dictionary/`
            },
            {
                label: `wfSubMenu4`,
                link: `${root.WORDFINDER}/unscramble/`
            },
            {
                label: `wfSubMenu5`,
                link: `${root.WORDFINDER}/word-cookies/`
            },
            {
                label: `wfSubMenu6`,
                link: `${root.WORDFINDER}/scrabble-checker/`
            },
            {
                label: `wfSubMenu7`,
                link: `${root.WORDFINDER}/words-with-friends-cheat/`
            },
            {
                label: `wfSubMenu8`,
                link: `${root.WORDFINDER}/game-cheats/`
            }
        ]
    }
];

export const sentencesIndexItems = [
    {
        label: "#",
        url: `${root.SENTENCES}/index/108-adu/#0`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/108-adu/#0"
    },
    {
        label: "A",
        url: `${root.SENTENCES}/index/108-adu/#A`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/108-adu/#A"
    },
    {
        label: "B",
        url: `${root.SENTENCES}/index/aur-bap/#B`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/aur-bap/#B"
    },
    {
        label: "C",
        url: `${root.SENTENCES}/index/bum-cam/#C`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/bum-cam/#C"
    },
    {
        label: "D",
        url: `${root.SENTENCES}/index/cys-dek/#D`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/cys-dek/#D"
    },
    {
        label: "E",
        url: `${root.SENTENCES}/index/dut-emc/#E`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/dut-emc/#E"
    },
    {
        label: "F",
        url: `${root.SENTENCES}/index/eyr-fig/#F`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/eyr-fig/#F"
    },
    {
        label: "G",
        url: `${root.SENTENCES}/index/fro-gem/#G`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/fro-gem/#G"
    },
    {
        label: "H",
        url: `${root.SENTENCES}/index/gug-hat/#H`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/gug-hat/#H"
    },
    {
        label: "I",
        url: `${root.SENTENCES}/index/hou-ill/#I`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/hou-ill/#I"
    },
    {
        label: "J",
        url: `${root.SENTENCES}/index/iro-jud/#J`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/iro-jud/#J"
    },
    {
        label: "K",
        url: `${root.SENTENCES}/index/jud-kno/#K`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/jud-kno/#K"
    },
    {
        label: "L",
        url: `${root.SENTENCES}/index/kno-lau/#L`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/kno-lau/#L"
    },
    {
        label: "M",
        url: `${root.SENTENCES}/index/lub-mam/#M`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/lub-mam/#M"
    },
    {
        label: "N",
        url: `${root.SENTENCES}/index/mon-nab/#N`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/mon-nab/#N"
    },
    {
        label: "O",
        url: `${root.SENTENCES}/index/nig-obl/#O`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/nig-obl/#O"
    },
    {
        label: "P",
        url: `${root.SENTENCES}/index/orf-pai/#P`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/orf-pai/#P"
    },
    {
        label: "Q",
        url: `${root.SENTENCES}/index/puk-rad/#Q`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/puk-rad/#Q"
    },
    {
        label: "R",
        url: `${root.SENTENCES}/index/puk-rad/#R`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/puk-rad/#R"
    },
    {
        label: "S",
        url: `${root.SENTENCES}/index/rur-sav/#S`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/rur-sav/#S"
    },
    {
        label: "T",
        url: `${root.SENTENCES}/index/sym-tel/#T`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/sym-tel/#T"
    },
    {
        label: "U",
        url: `${root.SENTENCES}/index/tu--und/#U`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/tu--und/#U"
    },
    {
        label: "V",
        url: `${root.SENTENCES}/index/und-val/#V`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/und-val/#V"
    },
    {
        label: "W",
        url: `${root.SENTENCES}/index/vit-wei/#W`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/vit-wei/#W"
    },
    {
        label: "X",
        url: `${root.SENTENCES}/index/wis-zea/#X`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/wis-zea/#X"
    },
    {
        label: "Y",
        url: `${root.SENTENCES}/index/wis-zea/#Y`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/wis-zea/#Y"
    },
    {
        label: "Z",
        url: `${root.SENTENCES}/index/wis-zea/#Z`,
        hardCodedUrl: "https://sentence.yourdictionary.com/index/wis-zea/#Z"
    }
];



// WEBPACK FOOTER //
// ./src/common/navigation.js